module.exports = __webpack_public_path__ + "media/application/images/svgs/chevron-right-422c8869988bc7cd636628f82d70c4a9.svg";